import { render, staticRenderFns } from "./ListAlunos.vue?vue&type=template&id=73f6cce2&"
import script from "./ListAlunos.vue?vue&type=script&lang=js&"
export * from "./ListAlunos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports